module.exports = __webpack_public_path__ + "img/audio2 2.b57675da.jpg";